<script setup lang="ts">
import type { ButtonIconOptions } from '/#/components/base/button/button'
import type { InformationIconProps } from '/#/components/partial/informationIcon'

withDefaults(defineProps<InformationIconProps>(), {
  iconColor: undefined,
  trigger: 'mouseenter focus',
  modalTitle: undefined,
  placement: 'bottom',
  iconSize: 'md',
  content: undefined,
})

const { t } = useI18n()
const { isModalOpen, openModal, closeModal } = useModals()
</script>

<template>
  <div v-if="useModal">
    <Button
      :icon="{ name: 'info', color: iconColor } as ButtonIconOptions"
      variant="link"
      circle
      color="tertiary"
      @click="openModal"
    />

    <Modal
      :title="modalTitle || t('common.information')"
      :open="isModalOpen"
      cancel-button
      show-footer
      :cancel-label="t('action.close')"
      @close="closeModal"
    >
      <template #content>
        <div class="content-modal">{{ content }}</div>
      </template>
    </Modal>
  </div>

  <div
    v-else
    v-tippy="content"
    :class="[
      iconColor
        ? ''
        : iconTheme === 'dark'
          ? 'dark-information-icon'
          : 'light-information-icon',
    ]"
  >
    <Icon name="info-information" :color="iconColor" />
  </div>
</template>

<style lang="scss" scoped>
.content-modal,
.content-tippy {
  font-size: 0.75rem !important;
  font-weight: 500;
  line-height: 1.5;
}

.content-tippy {
  max-width: 20em;
}

.information-icon {
  @apply cursor-pointer;
}

.light-information-icon {
  :deep(.app-icon) {
    @apply text-slate-300 #{!important};
  }
}

.dark-information-icon {
  :deep(.app-icon) {
    @apply text-slate-500 #{!important};
  }
}
</style>
